// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RelatedPosts_wrapper__1iJtn","recordsWrapper":"RelatedPosts_recordsWrapper__QCx_T","navWrap":"RelatedPosts_navWrap__KHAta"};